import { useState } from "react";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";

import { HeaderProfileMenu } from "./HeaderProfileMenu";

type ProfileProps = {
  name: string;
  avatarUrl?: string;
};

function HeaderProfile({ name, avatarUrl }: ProfileProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="flex items-center space-x-3">
      <span className="font-medium text-lg hidden md:inline">Olá, {name}</span>
      <IconButton onClick={handleOpen} size="small">
        <Avatar alt={name} src={avatarUrl || undefined}>
          {!avatarUrl && name[0]}
        </Avatar>
      </IconButton>
      <HeaderProfileMenu anchorEl={anchorEl} onClose={handleClose} />
    </div>
  );
}

export default HeaderProfile;
